module.exports = __webpack_public_path__ + "static/media/kuantumPapers.3eeb3110.svg";